/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
# These exports are for client side use only
# Importing into post office backend without a bundler will break the build
#
# Generate source: local/cli/src/commands/generate-all/team-export.ts
*/
import { lazy } from "react";

export default {
	'rovo-button-onboarding-spotlight': lazy(
			() =>
			import(
				/* webpackChunkName: "[request]" */
				'@post-office/message-template--rovo-button-onboarding-spotlight/placements/in-app/screen-space-flags/render'
			),
	),
	'rovo-extension-gdocs-definitions-install-cta-flag': lazy(
			() =>
			import(
				/* webpackChunkName: "[request]" */
				'@post-office/message-template--rovo-extension-gdocs-definitions-install-cta-flag/placements/in-app/screen-space-flags/render'
			),
	),
};
